import React from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Slider, Button } from 'hosman-material';
import { S_LocationDot, D_HouseBuilding, S_UpRightAndDownLeftFromCenter , D_Puzzle, D_CircleSort, D_CalendarDays, D_User, D_Gear, D_EuroSign, D_SignHanging, D_Handshake } from 'hosman-material';

import { updateLoginModalOpen } from '../../../../../../../reducers/_Pages/Public/radarSlice';

const BlurredInfos = ({ property }) => {
  const dispatch = useDispatch();

  return (
    <div className='overflow-hidden'>
      <Slider
        insideArrows
        items={Array.from({ length: 10 }).map((_, index) => {
          return (
            <div className='w-72 xl:w-80'>
              <img key={index} src={property.main_picture_url} className={`object-cover rounded-lg ${index === 0 ? '' : 'blur'}`} />
            </div>
          )
        })}
      />

      <div className='grid grid-cols-1 xl:grid-cols-2 gap-6 p-5 text-sm'>
        <div className='flex flex-col gap-3'>
          <p className='h3'>Le bien</p>
          
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={S_LocationDot} /></div>
            <p className='line-clamp-3 whitespace-pre-line pr-1'>Adresse : <span className='blur-sm'>1. Boulevard Hosman, 75002 Paris</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_HouseBuilding} /></div>
            <p>Type de bien : <span className='blur-sm'>Appartement</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={S_UpRightAndDownLeftFromCenter} /></div>
            <p>Surface : <span className='blur-sm'>84 m²</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_Puzzle} /></div>
            <p>Nombre de pièces : <span className='blur-sm'>4</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_CircleSort} /></div>
            <p>Etage : <span className='blur-sm'>5/5</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_Gear} /></div>
            <p>Prestations : <span className='blur-sm'>Cave, Box à vélo, Ascenceur, Gardien, Terrasse</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <p>DPE : </p>
            <div className='relative flex justify-center items-center w-9 h-9 rounded-xl bg-ih-neutral-60 blur-sm'>
              <p className='text-ih-neutral font-semibold'>X</p>
            </div>
          </div>
        </div>

        <div className='flex flex-col gap-3'>
          <p className='h3'>La vente</p>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_CalendarDays} /></div>
            <p>Date de la vente : <span className='blur-sm'>septembre 2018</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_User} /></div>
            <p>Profil acquéreur : <span className='blur-sm'>Primo entre 30 et 40 ans</span></p>
          </div>
          
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_EuroSign} /></div>
            <p>Prix de vente réel : <span className='blur-sm'>300 000€ (11 350€/m²)</span></p>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_SignHanging} /></div>
            <p>Prix affiché : <span className='blur-sm'>300 000€</span></p>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_Handshake} /></div>
            <p>Négociation : <span className='blur-sm'>0%</span></p>
          </div>

          <div className='flex justify-end'>
            <Button label='Débloquer la data' onClick={() => dispatch(updateLoginModalOpen(true))} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlurredInfos;
